module.exports = __webpack_public_path__ + "static/new_session_list_preview-680d6d706b475a3d15759fd56b7f0382.png";